// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"525983412f531e33c82d","691":"43cb581e4a696e2d8ea0"}[chunkId] + ".js";
};